import { render, staticRenderFns } from "./TableBuilder.vue?vue&type=template&id=9d3df46c&scoped=true&"
import script from "./TableBuilder.vue?vue&type=script&lang=ts&"
export * from "./TableBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./TableBuilder.vue?vue&type=style&index=0&id=9d3df46c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3df46c",
  null
  
)

export default component.exports